<template>
  <div class="bottom-area">
    <div class="company-intro">
      <p class="first-line">
        Copyright 上海掌小门教育科技有限公司（
        <a href="http://www.miibeian.gov.cn" target="_blank">沪ICP备16015460号-20</a>）
      </p>
      <p class="second-line">
        掌门1对1属于上海掌小门教育科技有限公司所有 |
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502000499"
        >沪公网安备 31010502000499号</a>
      </p>
      <p class="third-line">客服电话：021-10108868<br/>公司地址：上海市宝山区</p>
      <p class="second-line">
        <a
          target="_blank"
          href="https://www.zhangmen.com/teachers"
        >教师资格公示</a>
      </p>
      <img src="./img/pic_verification.png" alt>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zm-footer',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.bottom-area {
  padding-top: px2rem(55);
  .company-intro {
    background: #363636;
    border-top: 1px solid #666;
    text-align: center;
    padding-top: px2rem(30);
    line-height: 1.5em;
    .first-line,
    a {
      font-size: px2rem(20);
      color: #b2b2b2;
    }
    .second-line,
    a {
      font-size: px2rem(16);
      color: #999;
    }
    .third-line {
      font-size: px2rem(16);
      color: #999;
    }
    img {
      width: px2rem(210);
      margin-top: px2rem(30);
      padding-bottom: px2rem(50);
    }
  }
}
</style>
